// extracted by mini-css-extract-plugin
export default {"root":"IconChat_root__9ImR5"};